import React, { useState } from "react";
import {
  Button,
  InputAdornment,
  MenuItem,
  TextField,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Person3Icon from "@mui/icons-material/Person3";
import PasswordIcon from "@mui/icons-material/Password";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SchoolIcon from "@mui/icons-material/School";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import CakeIcon from "@mui/icons-material/Cake";
import provincesData from "../../common/province.json";

export default function UserForm({
  formData,
  handleChangeInputUser,
  handleInsertUser,
  isEditing,
  handleUpdateUser,
}) {
  const [provinces, setProvinces] = useState(provincesData);
  // Handle courses checkbox changes
  const handleCoursesChange = (course) => {
    const currentCourses = formData.courses || [];
    console.log("🚀 ~ handleCoursesChange ~ currentCour:", currentCourses);
    let newCourses;

    if (currentCourses.includes(course)) {
      // Remove course if already selected
      newCourses = currentCourses.filter((c) => c !== course);
    } else {
      // Add course if not selected
      newCourses = [...currentCourses, course];
    }

    handleChangeInputUser({
      target: {
        name: "courses",
        value: newCourses,
      },
    });
  };

  return (
    <div className="p-6 max-w-3xl mx-auto bg-white shadow-lg rounded-lg mb-[50px]">
      <h2 className="text-2xl font-bold text-center mb-6">
        {isEditing
          ? "Cập nhật thông tin người dùng"
          : "Tạo tài khoản người dùng"}
      </h2>
      <div className="mb-5 flex justify-around flex-wrap">
        <TextField
          label="Email *"
          name="email"
          value={formData?.email}
          className="md:w-[300px] w-[100%] lg:mb-0 mb-5 label-text"
          onChange={handleChangeInputUser}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
        />
        <TextField
          label="Tên người dùng *"
          name="fullName"
          value={formData?.fullName}
          onChange={handleChangeInputUser}
          className="md:w-[300px] w-[100%] label-text"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person3Icon />
              </InputAdornment>
            ),
          }}
          variant="standard"
        />
      </div>

      <div className="mb-5 flex justify-around flex-wrap">
        <TextField
          label="Số điện thoại *"
          name="phoneNumber"
          value={formData?.phoneNumber}
          className="md:w-[300px] w-[100%] lg:mb-0 mb-5 label-text"
          onChange={handleChangeInputUser}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PhoneIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
        />
        <TextField
          label="Năm sinh *"
          name="yearOfBirth"
          value={formData?.yearOfBirth}
          onChange={handleChangeInputUser}
          className="md:w-[300px] w-[100%] label-text"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <CakeIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
          placeholder="YYYY"
        />
      </div>

      <div className="mb-5 flex justify-around flex-wrap">
        {/* <TextField
          label="Thành phố *"
          name="city"
          value={formData?.city}
          className="md:w-[300px] w-[100%] lg:mb-0 mb-5 label-text"
          onChange={handleChangeInputUser}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocationCityIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
        /> */}

        <select
          name="city"
          value={formData.city}
          onChange={handleChangeInputUser}
          className="md:w-[300px] w-[100%] lg:mb-0 mb-5 label-text border border-gray-400 bg-white/70 pl-4 pr-10 text-[#4b4b4b] focus:outline-none focus:ring-2 focus:ring-[#db3b6d] appearance-none"
        >
          <option value="">{"Chọn tỉnh/thành phố"}</option>
          {provinces.map((p) => (
            <option key={p.code} value={p.name}>
              {p.name}
            </option>
          ))}
        </select>
        <TextField
          label="Trường học *"
          name="school"
          value={formData?.school}
          onChange={handleChangeInputUser}
          className="md:w-[300px] w-[100%] label-text"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SchoolIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
        />
      </div>

      <div className="mb-5 flex justify-around flex-wrap">
        <TextField
          label="Password *"
          name="password"
          type="password"
          value={formData?.password}
          className="md:w-[300px] w-[100%] lg:mb-0 mb-5 label-text"
          onChange={handleChangeInputUser}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PasswordIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
        />
        <TextField
          select
          label="Role *"
          name="role"
          value={
            formData?.role === 1 ? "Admin" : formData?.role === 0 ? "User" : ""
          }
          onChange={handleChangeInputUser}
          className="label-text md:w-[300px] w-[100%] lg:mb-0 mb-5"
          variant="standard"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AdminPanelSettingsIcon />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            shrink: true,
          }}
        >
          {["Admin", "User"].map((option, key) => (
            <MenuItem key={key} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </div>

      <div className="mb-5 flex justify-around flex-wrap px-[130px]">
        {isEditing ? (
          <Button
            variant="contained"
            component="label"
            className="label-text md:w-[250px] w-[100%] py-[10px]"
            startIcon={<CloudUploadIcon />}
            onClick={handleUpdateUser}
          >
            Cập nhật tài khoản
          </Button>
        ) : (
          <Button
            variant="contained"
            component="label"
            className="label-text md:w-[200px] w-[100%] py-[10px]"
            startIcon={<CloudUploadIcon />}
            onClick={handleInsertUser}
          >
            Tạo tài khoản
          </Button>
        )}
      </div>
    </div>
  );
}
